<template>
    <div class="solution-agriculture-page">
        <div class="page-content">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="solution-children-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <solution-info-block :data-val="dataInfo"></solution-info-block>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import SolutionInfoBlock from '../../../../../components/solution-info-block/solution-info-block'
    import AgricultureShow from '../../../../image/agriculture_show.png'
    export default {
        name: "solution-agriculture-page",
        components:{
            SolutionInfoBlock
        },
        data(){
            return{
                dataInfo:{
                    business:[
                        {title:null,info:['智慧农业是“互联网+”时代社区管理的一种新理念，是新经济形势下社会管理创新的一种全新模式。智慧物联网作为信息产业的第 3 次革命浪潮，正在深远地影响社会生产生活的各个方面，成为人们关注和研究的热点。物联网和农业结合所形成的农业物联网使低效率的传统生产模式转向以信息和软件为中心的智能化生产模式，将有力地推动农业生产力的发展。农业物联网正在引领农业传统生产经营模式的变革和升级，成为改变农业、农民、农村的新力量。近年来，国际上许多发达国家正在加速推进农业物联网的技术研发和产业化应用，在信息感知、数据处理、技术应用和智能服务等领域取得重要进展，产生很多新型传感装备、软件系统和产业化应用模式。']},
                        {list:[
                                {title:'智慧农业有如下建设诉求：',info: null},
                                {title:'1）一张能覆盖整个地区、统一无线技术标准的泛在网络',info: '目前智慧农业多采用GPRS/有线等传输技术，缺乏统一规划，每个设备终端都需插入SIM卡或者布线对整个项目实施与维护都会增加成本。使用的技术标准多样化，并非大数据共享的“万物互联”。比如一个农场里遮阳棚系统与灌溉系统是两个信息孤岛，大田里使用的监测终端设备更是五花八门。迫切需要标准统一的物联网技术来统一规划覆盖社区3-15km周边的无线网络。'},
                                {title:'2）无布线/少布线的监测设备与一体化终端',info: '现阶段智慧农业的传感设备与监测终端多为解耦机制，布线复杂、功耗高，IP防护安全级别低，。而大田种植与大棚种植现场布线与取电较困难，智慧农业应当把物联的“智慧”和农户的纽带关系建立，这是智慧农业的延展要求，特别是加强种植环境感知（土壤温湿度，光合有效），是保证农作物稳定的需要重要手段。'},
                                {title:'3）亟需提升农业智能化管理与服务水平，提高数据感知能力',info: '智慧农业物联网是综合应用物联网、互联网、云计算、智能控制、智能决策等现代信息技术，依托部署在农业生产现场的各种传感终端设备，例如土壤温湿度、空气温湿度、二氧化碳浓度、风速风向、水质水位、光照度等，和无线通信网络实现农业生产环境的智能感知、智能预警、智能决策、智能分析、专家在线指导，为农业生产提供科学化种植/养殖、可视化管理、智能化决策。'},
                            ]}
                    ],
                    programme:[{
                        image:AgricultureShow,info:'智慧农业解决方案依据，十九大提出了“加快推进农业农村现代化”，推动工业化、信息化、城镇化、农业现代化同步发展。国务院、部、省、市各级政府出台相关文件加快推进农业现代化建设，推进农业现代化与信息化同步发展。利用物联网、大数据、云计算等新一代信息技术整合社区资源，依托一张统一标准的，并覆盖农业大田、大棚的LoRa物联网络、以及在农业内的各类终端传感设备（比如空气温湿度计、土壤温湿度计、太阳辐射监测、环境监测、水质监测、土壤PH值、土壤盐度设备等），为农业农户提供高效、便携和智慧的服务。为新农人运营及工作人员提供集规划部署、日常运维、实时感知在内的设备全生命周期管理；同时整网可支持快速的功能扩展并与第三方系统对接，让农业网络更好地为运营方提供业务服务。'
                    }],
                    customerTitle:'客户价值',
                    customer:[
                        {title:'一、统一无线接入标准、可实现社区2~3km、室内及室外连续覆盖，避免信息孤岛。',info:['LoRa技术远距传输、覆盖范围广、低功耗。','LoRa穿透力强、覆盖成本更低、容易部署。']},
                        {title:'二、系列化工业级网关适配社区多应用场景，轻量级网路降低客户TCO成本，拓展客户盈利渠道。',info:['系列化网关适配多场景，信号补盲成本低，更容易实现网络深度覆盖。','LoRa网关辐射小，社区建设易选址，网络部署周期缩短50%以上。','连接成本低，运营费用降低60%以上，商业运营模式更灵活。']},
                        {title:'三、 灵活组态的创新通用传感组件平台GSP和应用管理平台infiCombo2.0，助力客户快速开发集成丰富的物联网应用场景。',info:[' GSP开放性、组件化平台，可灵活组态应用终端，使能合作伙伴快速开发适配碎片化应用场景、多种供电模式、各种工业标准接口、接入数千种传统传感器的应用。低成本、高效、快速集成。','InfiCombo2.0应用管理平台降低物联网集成商的门槛和投入，无需通信认证开发，快速开发应用集成交付，且提供二次开发接口给大型的应用平台提供商。']},
                        {title:'四、主导物联网生态圈，联合1300+合作伙伴提供商用更成熟、丰富的应用及端到端解决方案。',info:['商业应用更成熟、终端成本更低。 ','网络开放性、可扩展性好，生态链更丰富且成熟。']},
                    ],
                }
            }
        }
    }
</script>

<style lang="scss" src="../../solution-page.scss" scoped>

</style>
